import ErrorMessage from '@shared/components/ErrorMessage/ErrorMessage';
import { PropsWithChildren } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ClipboardText } from 'assets/icons/ClipboardText.svg';
import TextInput from 'components/TextInput/TextInput';
import constants from 'Constants';

import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';

const InvitationMessageField = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const {
    roomForm: {
      control,
      formState: { errors },
    },
  } = useCreateNewRoomDataContext();

  const error = errors.invitationMessage?.message;

  return (
    <div className="flex gap-5">
      <ClipboardText className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5" />
      <div className="flex flex-col w-full">
        <div className="flex flex-col w-full gap-3">
          {children}
          <Controller
            name="invitationMessage"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextInput
                id="invitationMessage"
                value={value}
                hasError={!!error}
                maxLength={constants.MAX_INVITATIONS_MESSAGE_LENGTH + 1}
                onChange={onChange}
                placeholder={t('invitation_message_placeholder')}
              />
            )}
          />
        </div>
        <ErrorMessage message={error} />
      </div>
    </div>
  );
};

export default InvitationMessageField;
